<template>
  <div class="page-footer">
    <div class=row>
      <div class="col-sm-6 footer-left">
        <p class="support"><strong> For technical support contact: </strong> <a href="mailto:scholarship@taphere.com">scholarship@taphere.com</a></p>
      </div>
    <div class="col-sm-6 footer-right">
      <p class="text-right w-100">
        Powered by
        <img src="../assets/th-logo.png" class="taphere-logo" align="right" alt="Taphere! Technology">
      </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScholarshipFooter',
  components:{
  },
  data(){
    return {
    }
  },
  mounted(){
  },
  methods:{
  }
}
</script>

<style lang="scss" scoped>

.page-footer {
  background-color: white;
  color: #bfbfbf;
  height: 125px;
}

.taphere-logo {
  height: 4em;
  margin-right: 3em;
}

.footer-right {
  margin-top: 2em;
}

.footer-left {
  margin-top: 3em;
}

a {
  color: #8f8f8f !important;
}

a:hover {
  color: #5f5f5f !important;
}

.support {
  margin-left: 3em;
}

</style>
